import React from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Typography } from '@material-ui/core';

import { IntlMsg } from '../IntlMsg/intl-msg.component';
import { PrimaryButton } from '../_ui/buttons.component';
import { AuthFailureReason } from '../../../lib/types/auth-failure.types';
import { messages } from './access-link-rejected.messages';

interface IAccessLinkRejectedProps {
  reason: AuthFailureReason;
  signInPath: string;
}

export const AccessLinkRejected: React.FC<IAccessLinkRejectedProps> = ({ reason, signInPath }) => {
  const history = useHistory();

  return (
    <Box textAlign="center">
      <Typography variant="h5" gutterBottom>
        <IntlMsg {...(reason === AuthFailureReason.ACCESS_LINK_EXPIRED ? messages.expiredTitle : messages.invalidTitle)} />
      </Typography>
      <Typography variant="body1" color="textSecondary" paragraph>
        <IntlMsg {...messages.body} />
      </Typography>
      <PrimaryButton variant="contained" onClick={() => history.push(signInPath)}>
        <IntlMsg {...messages.signIn} />
      </PrimaryButton>
    </Box>
  );
};
